import { isArray } from '@dimjs/lang';
import { classNames, extend } from '@dimjs/utils';
import { cloneElement } from 'react';
import { CommonPropsWithChildren, withNativeProps } from '../utils';
import { numberPx2rem } from '../utils/pxrem';
import './style.less';
import { ListItemVarStyle } from './type';

export type ListProps = {
  mode?: 'default' | 'card';
  // 上线间距
  gap?: number;
} & CommonPropsWithChildren<ListItemVarStyle>;

export const List = (props: ListProps) => {
  const gap = numberPx2rem(props.gap);

  const childrenList = isArray(props.children) ? props.children : [props.children];
  const listStyle = gap ? { marginBottom: `-${gap}`, overflow: 'hidden' } : {};
  return withNativeProps(
    props,
    <div className={classNames('v-list', `v-list-${props.mode || 'default'}`)} style={listStyle}>
      {childrenList.filter(Boolean).map((children, index) => {
        const childrenStyle = gap ? { marginBottom: gap } : null;
        return cloneElement(children, {
          key: index,
          style: extend({}, childrenStyle, children?.['props']?.style),
        });
      })}
    </div>,
  );
};
